import { graphql } from "react-relay";
import "./autopilot-suggestion-invite/AutopilotSuggestionInvite.gql";
import "./autopilot-suggestion-enable-meeting/AutopilotSuggestionEnableMeeting.gql";
import "./autopilot-suggestion-lessen-constraint/AutopilotSuggestionLessenConstraint.gql";

export const fragments = {
  org: graphql`
    fragment AutopilotSuggestionsCard_org on Org {
      ...AutopilotSuggestionInvite_org
      ...AutopilotSuggestionEnableMeeting_org
      ...AutopilotSuggestionLessenConstraint_org
      id
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          defragTime
          impactedOtherCalendarIds
          valueStrings
          knobs {
            inviteOrganizerKnobs {
              __typename
              knobUrn {
                id
                type
                value
              }
              ...AutopilotSuggestionInvite_inviteOrganizerKnob
            }
            autopilotMeetingKnobs {
              __typename
              knobUrn {
                id
                type
                value
              }
              ...AutopilotSuggestionEnableMeeting_autopilotMeetingKnob
            }
            lessenAutopilotConstraintKnobs {
              __typename
              knobUrn {
                id
                type
                value
              }
              ...AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob
            }
          }
          referencedEvents {
            ...AutopilotSuggestionInvite_referencedEvents
            ...AutopilotSuggestionEnableMeeting_referencedEvents
            ...AutopilotSuggestionLessenConstraint_referencedEvents
            eventKey {
              externalEventId
            }
          }
          persons {
            __typename
            ... on PersonList {
              list {
                primaryEmail
                profile {
                  givenName
                  familyName
                  externalImageUrl
                }
              }
            }
          }
          rooms {
            __typename
            ... on RoomList {
              list {
                roomId
                name
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};
